import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
    ID,
    calculatedGroupingIsDisabled,
    calculateIsAllDataSelected,
    groupingOnSelect,
    initialListView,
    ListViewContextProps,
    groupingOnSelectAll,
    WithChildren,
} from '../../../../../_metronic/helpers'

import {useDLMThresholdQueryResponse, useDLMThresholdQueryResponseData} from './DLMThresholdQueryResponseProvider'

const DLMThresholdListViewContext = createContext<ListViewContextProps>(initialListView)

const DLMThresholdListViewProvider: FC<WithChildren> = ({children}) => {

    const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
    
    const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
    const [itemIdForDelete, setItemIdForDelete] = useState<ID>(initialListView.itemIdForDelete)
    const [objectOption1, setObjectOption1] = useState<object | null>(null)
    
    const {isLoading} = useDLMThresholdQueryResponse()
    const data = useDLMThresholdQueryResponseData()
    const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
    const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])
    
    return (
    <DLMThresholdListViewContext.Provider
        value={{
            selected,
            itemIdForUpdate,
            setItemIdForUpdate,
            itemIdForDelete,
            setItemIdForDelete,
            objectOption1, 
            setObjectOption1,
            disabled,
            isAllSelected,
            onSelect: (id: ID) => {
            groupingOnSelect(id, selected, setSelected)
            },
            onSelectAll: () => {
            groupingOnSelectAll(isAllSelected, setSelected, data)
            },
            clearSelected: () => {
            setSelected([])
            },
        }}
    >
        {children}
    </DLMThresholdListViewContext.Provider>
    )
}

const useDLMThresholdListView = () => useContext(DLMThresholdListViewContext)

export { DLMThresholdListViewProvider, useDLMThresholdListView }
